import { getDate } from 'date-fns';
import { IEnrichedFlight } from '../features/flights/shared/flight/domain/models/IEnrichedFlight';
import { getFlightDateTime } from './getFlightDateTime';

type FlightDayGroup = {
	id: string;
	dateTime: Date;
	flights: IEnrichedFlight[];
};

export function generateFlightsDayGroups(flights: IEnrichedFlight[]) {
	const firstFlight = flights[0];
	if (!firstFlight) return [];

	const dateTime = getFlightDateTime(firstFlight);
	let group: FlightDayGroup = { id: firstFlight.id, dateTime, flights: [] };
	const dayGroups = [group];

	for (const flight of flights) {
		const newDateTime = getFlightDateTime(flight);
		if (getDate(group.dateTime) !== getDate(newDateTime)) {
			group = { id: flight.id, dateTime: newDateTime, flights: [] };
			dayGroups.push(group);
		}
		group.flights.push(flight);
	}

	return dayGroups;
}
